import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDzHm656F7pPQgC3N_33kZYlbMy84TZR1E",
  authDomain: "https://accounts.google.com/o/oauth2/auth",
  databaseURL: "https://smart-school-kzbgn7.firebaseio.com",
  projectId: "smart-school-kzbgn7",
  storageBucket: "smart-school-kzbgn7.firebasestorage.app",
  messagingSenderId: "107435169212721791618",
  appId: "1:1035938954820:android:6fb9004fa61651ab538611"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
